<candidate-main-layout [leftNavEnabled]="false"></candidate-main-layout>
